import React from 'react';
import { useTranslation } from 'react-i18next';
import { isMobile } from 'helpers';
import PostFormHeaderTitle from '../Partials/PostFormHeaderTitle';
import useBackClick from './useBackClick';

const QuizViewHeader = () => {

  const { t } = useTranslation('component');

  const onBackClick = useBackClick();

  if (isMobile) {
    return null;
  }

  return (
    <PostFormHeaderTitle onBackClick={onBackClick}>{t('quizForm.title')}</PostFormHeaderTitle>
  );
};

export default QuizViewHeader;
